import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCustomPaymentTypesForForm } from '@/api/hooks/custom-payments/useGetCustomPaymentTypesForForm';

const CustomPaymentTypeSelect = ({ value, onChange, permissionKeyParent }) => {
  const { t } = useTranslation();

  const { customPaymentTypes } = useGetCustomPaymentTypesForForm(
    true,
    null,
    false,
    permissionKeyParent,
  );

  return (
    <div
      className='t-header-left'
      style={{ marginTop: 0, padding: 0, paddingLeft: '10px' }}>
      <div className='custom-search-box'>
        <div
          className='custom-select'
          style={{ marginTop: 0, paddingBottom: 0 }}>
          <select
            id='custom-payment-type'
            className='full-width-elem'
            value={value}
            onChange={onChange}
            style={{ height: '35px' }}>
            <option value=''>
              {t(
                'payments.filters.customPaymentTypePlaceholder',
                'Select Payment Type',
              )}
            </option>
            {customPaymentTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>
        <span className='search-icon'></span>
      </div>
    </div>
  );
};

export default CustomPaymentTypeSelect;
